const normalizeOptionalString = (value = '') => {
  const normalized = String(value || '').trim();
  return normalized || null;
};

const normalizeOptionalIndex = (value = null) => (
  Number.isInteger(value) && value >= 0 ? value : null
);

const normalizeDetectedDate = (value = null) => {
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return new Date(value);
  }

  if (typeof value === 'string' && value.trim()) {
    return value.trim();
  }

  return null;
};

const normalizeDetectedTime = (value = null) => {
  const normalized = String(value || '').trim();
  return normalized || null;
};

export const buildImportCandidateRow = (row = {}, {
  rawSourceText = '',
  sourceBlockId = null,
  sourceSentenceIndex = null,
  detectedDate = null,
  detectedTime = null,
  categoryHint = null,
  titleHint = null,
  parserMode = '',
  sourceMode = '',
} = {}) => {
  const resolvedRawSourceText = String(
    rawSourceText
    || row?.rawSourceText
    || row?.sourceText
    || row?.originalText
    || row?.text
    || ''
  ).trim();

  const resolvedParserMode = String(parserMode || row?.parserMode || row?.metadata?.parserMode || '').trim();
  const resolvedSourceMode = String(sourceMode || row?.sourceMode || row?.metadata?.sourceMode || '').trim();

  return {
    ...row,
    rawSourceText: resolvedRawSourceText,
    sourceBlockId: normalizeOptionalString(sourceBlockId || row?.sourceBlockId),
    sourceSentenceIndex: normalizeOptionalIndex(
      sourceSentenceIndex ?? row?.sourceSentenceIndex ?? row?.metadata?.sourceSentenceIndex
    ),
    detectedDate: normalizeDetectedDate(detectedDate ?? row?.detectedDate ?? row?.date ?? null),
    detectedTime: normalizeDetectedTime(
      detectedTime ?? row?.detectedTime ?? row?.localTime ?? null
    ),
    categoryHint: normalizeOptionalString(categoryHint || row?.categoryHint || row?.parsedSourceCategory),
    titleHint: normalizeOptionalString(titleHint || row?.titleHint || row?.title || row?.titlePrefix),
    parserMode: resolvedParserMode || row?.parserMode || '',
    sourceMode: resolvedSourceMode || row?.sourceMode || '',
    metadata: {
      ...(row?.metadata || {}),
      rawSourceText: resolvedRawSourceText,
      sourceBlockId: normalizeOptionalString(sourceBlockId || row?.sourceBlockId || row?.metadata?.sourceBlockId),
      sourceSentenceIndex: normalizeOptionalIndex(
        sourceSentenceIndex ?? row?.sourceSentenceIndex ?? row?.metadata?.sourceSentenceIndex
      ),
      detectedDate: normalizeDetectedDate(detectedDate ?? row?.detectedDate ?? row?.date ?? null),
      detectedTime: normalizeDetectedTime(
        detectedTime ?? row?.detectedTime ?? row?.localTime ?? null
      ),
      categoryHint: normalizeOptionalString(categoryHint || row?.categoryHint || row?.parsedSourceCategory),
      titleHint: normalizeOptionalString(titleHint || row?.titleHint || row?.title || row?.titlePrefix),
      parserMode: resolvedParserMode || row?.parserMode || row?.metadata?.parserMode || '',
      sourceMode: resolvedSourceMode || row?.sourceMode || row?.metadata?.sourceMode || '',
    },
  };
};
